module.exports = __webpack_public_path__ + "static/img/36.97d94dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/36.png
// module id = wnCV
// module chunks = 0